<script setup>
import { useInterpolatedContent } from '@/app/composables/useInterpolatedContent.js';
import ProductListingFilterToggle from '@/app/components/product-listing/product-listing-filter-toggle.vue';
import ProductListingFilterTags from '@/app/components/product-listing/product-listing-filter-tags.vue';
import ProductListingFilterSelect from '@/app/components/product-listing/product-listing-filter-select.vue';

import { inject, computed } from 'vue';
const config = inject('config');

import { useProductsStore } from '@/app/stores/productsStore.js';

const productsStore = useProductsStore();

const cmsMessageProps = computed(() => {
  return {
    productsShowingCount: productsStore.filteredProductsCount,
    productsTotalCount: productsStore.allProductsCount,
  };
});

const resultCount = computed(() =>
  useInterpolatedContent(config.resultCount, cmsMessageProps.value),
);
</script>

<template>
  <div class="c-product-listing-filter" :class="{ 'mobile-hide': productsStore.hideFilterMobile }">
    <ProductListingFilterTags />
    <ProductListingFilterToggle />
    <div class="c-product-listing-filter__selects">
      <p class="c-product-listing-filter__selects-description">
        {{ config.selectDescription }}
      </p>
      <div class="c-product-listing-filter__selects-container">
        <ProductListingFilterSelect
          :class="{ 'mobile-hide': productsStore.hideFilterMobile }"
          v-for="(filter, i) in productsStore.dynamicFiltersArr"
          :key="filter.id"
          :selectPosition="i"
          :filter="filter"
        />
      </div>
    </div>
    <div class="c-product-listing-filter__filter_info">
      <p>{{ resultCount }}</p>
    </div>
  </div>
</template>